@for (constructionStep of constructionSheetData(); track $index) {
  <div class="p-4 border border-gray-200">
    <h2 class="text-lg font-medium">Construction Sheet</h2>
    <h2 class="text-lg font-medium ml-3 mt-3">
      Construction Step {{ isConstructionSheet ? '' : $index + 1 }}
    </h2>

    <p class="description ml-3">
      {{ isConstructionSheet ? description : description[$index] }}
    </p>
    <div class="pt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        @for (
          option of constructionStep.slice(0, Math.ceil(constructionStep.length / 2));
          track $index
        ) {
          <div class="mb-3">
            <mat-checkbox [disabled]="true" [checked]="option.checked">
              {{ option.label }}
            </mat-checkbox>
          </div>
        }
      </div>
      <div>
        @for (
          option of constructionStep.slice(Math.ceil(constructionStep.length / 2));
          track $index
        ) {
          <div class="mb-3">
            <mat-checkbox [disabled]="true" [checked]="option.checked">
              {{ option.label }}
            </mat-checkbox>
          </div>
        }
      </div>
    </div>
  </div>
}
